import { FileCsvIcon, FilePdfIcon, FileXlsIcon, UploadSimpleIcon } from '@phosphor-icons/react';
import { Dropdown } from 'antd';
import type { ReactNode } from 'react';

import { Button } from '@/components/common/button';
import { useExport, type ExportFormat } from '@/hooks/use-export';

import styles from './export-menu.module.scss';

export type ExportMenuProps = {
  endpoint: string;
  params: Record<string, string | number | undefined>;
  /** Base filename without extension. */
  filename: string;
  label?: string;
};

const FORMATS: { key: ExportFormat; label: string; icon: ReactNode }[] = [
  { key: 'xlsx', label: 'Excel', icon: <FileXlsIcon /> },
  { key: 'csv', label: 'CSV', icon: <FileCsvIcon /> },
  { key: 'pdf', label: 'PDF', icon: <FilePdfIcon /> },
];

export function ExportMenu({ endpoint, params, filename, label = 'Export' }: ExportMenuProps) {
  const exportMutation = useExport(endpoint);

  return (
    <Dropdown
      trigger={['click']}
      classNames={{ root: styles.popup }}
      menu={{
        items: FORMATS.map((f) => ({ key: f.key, label: f.label, icon: f.icon })),
        onClick: ({ key }) => {
          const format = FORMATS.find((f) => f.key === key)?.key;
          if (!format) return;
          exportMutation.mutate({ format, filename, params });
        },
      }}
    >
      <Button variant="outline" startIcon={<UploadSimpleIcon />} loading={exportMutation.isPending}>
        {label}
      </Button>
    </Dropdown>
  );
}
